import { difference, map } from 'lodash/fp';
import { createSelector } from 'reselect';

import { isAppFetching } from '../../modules/app/selectors';
import {
    hasSelectedCityAvailabilityFailed,
    isSelectedCityAvailabilityFetching,
} from '../../modules/availability/cityAvailability';
import {
    hasSelectedCityServiceAvailabilityFailed,
    isSelectedCityServiceAvailabilityFetching,
} from '../../modules/availability/serviceAvailability';
import { getConfigurationIds, getHotelIds } from '../../modules/configuration/selectors';
import { areAnyExchangeRatesFetching, hasAnyExchangeRatesFailed } from '../../modules/entities/exchangeRates/selectors';
import { getSelectedCityHotelsWithAvailableRooms } from '../../modules/hotels/selectors';
import { hasAnyPricingFailed, isAnyPricingFetching } from '../../modules/pricing/selectors';
import { areAnyProductsFetching } from '../../modules/products/selectors';
import { hasAnyServicePricingFailed, isAnyServicePricingFetching } from '../../modules/servicePricing';
import {
    areSelectedServiceCategoriesFetching,
    hasSelectedServiceCategoriesFailed,
} from '../../selectors/views/categories';
import { getSelectedCityEnterprisesIds } from '../../selectors/views/selectedCityEnterprises';
import { ApplicationState } from '../../types';

import { getEnterpriseWithAvailability, getViewEnterprise } from './typedSelectors';
import { sortEnterprises } from './utils';

const getViewHotelsWithAvailability = (state: ApplicationState) =>
    map(
        (enterpriseId) => getEnterpriseWithAvailability(state, { enterpriseId }),
        getSelectedCityHotelsWithAvailableRooms(state)
    );

export const isEnterprisesViewFetching = (state: ApplicationState) =>
    isAppFetching(state) ||
    isSelectedCityAvailabilityFetching(state, {}) ||
    isAnyPricingFetching(state) ||
    isAnyServicePricingFetching(state) ||
    areAnyExchangeRatesFetching(state) ||
    isSelectedCityServiceAvailabilityFetching(state) ||
    areSelectedServiceCategoriesFetching(state) ||
    areAnyProductsFetching(state);

export const hasEnterprisesViewFailed = (state: ApplicationState) =>
    hasSelectedCityAvailabilityFailed(state, {}) ||
    hasAnyExchangeRatesFailed(state) ||
    hasSelectedCityServiceAvailabilityFailed(state) ||
    hasAnyPricingFailed(state) ||
    hasAnyServicePricingFailed(state) ||
    hasSelectedServiceCategoriesFailed(state);

export const getSortedHotels = createSelector(
    getViewHotelsWithAvailability,
    getConfigurationIds,
    getHotelIds,
    sortEnterprises
);

const getSelectedCityEnterprisesWithoutAvailableCategories = createSelector(
    getSelectedCityEnterprisesIds,
    getSelectedCityHotelsWithAvailableRooms,
    difference
);

const getViewHotelsWithoutAvailability = (state: $TSFixMe) =>
    map(
        // @ts-expect-error $TSFixMeError: Expected 3 arguments, but got 2.
        (enterpriseId) => getViewEnterprise(state, { enterpriseId }),
        getSelectedCityEnterprisesWithoutAvailableCategories(state, {})
    );

export const getSortedViewHotelsWithoutAvailability = createSelector(
    getViewHotelsWithoutAvailability,
    getConfigurationIds,
    getHotelIds,
    sortEnterprises
);
